import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface SystemInfoReq {
  /** 设备id */
  device_id: string
}

export interface SystemInfoRes {
  /** 操作系统 */
  system_name: string
  /** 安装时间 */
  install_time: number
  /** 产品秘钥 */
  product_key: string
  /** 注册组织 */
  registered_organization: string
  /** 注册人 */
  registered_user: string
  /** 产品id */
  product_id: string
  /** 系统类型 */
  architecture: string
  /** 代码名称 */
  code_set?: string
  /** 核心类型 */
  build_type?: string
  /** 系统语言 */
  language?: string
  /** 授权处理器数量 */
  processors_count?: number
  /** 激活状态 1:已激活 2:未激活 */
  state_activation?: number
  /** 系统版本 */
  system_version?: string
  /** 系统升级包 */
  update_package?: string
}

@Injectable()
export class OperateSystemService {
  constructor (private http: Http) {
  }

  getSystemInfo (data: SystemInfoReq) {
    return this.http.post<SystemInfoRes>('/terminal/hardware/system_info', data)
  }
}
